import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { SharedModule } from '@games/speed-reading/shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
} from '@shared/components/games';
import { FontParametersModule } from '@shared/components/games/font-parameters/font-parameters.module';
import { MetronomeReadingControllerComponent } from './metronome-reading-controller/metronome-reading-controller.component';
import { MetronomeReadingCorrectAnswerPreviewComponent } from './metronome-reading-preview/metronome-reading-answer-preview/metronome-reading-answer-preview.component';
import { MetronomeReadingExamplePreviewComponent } from './metronome-reading-preview/metronome-reading-example-preview/metronome-reading-example-preview.component';
import { MetronomeReadingParametersPreviewComponent } from './metronome-reading-preview/metronome-reading-parameters-preview/metronome-reading-parameters-preview.component';
import { MetronomeReadingUserAnswerPreviewComponent } from './metronome-reading-preview/metronome-reading-user-answer-preview/metronome-reading-user-answer-preview.component';
import { MetronomeReadingSettingsComponent } from './metronome-reading-settings/metronome-reading-settings.component';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    MetronomeReadingControllerComponent,
    MetronomeReadingSettingsComponent,
    MetronomeReadingCorrectAnswerPreviewComponent,
    MetronomeReadingExamplePreviewComponent,
    MetronomeReadingParametersPreviewComponent,
    MetronomeReadingUserAnswerPreviewComponent,
  ],
  exports: [
    MetronomeReadingControllerComponent,
    MetronomeReadingSettingsComponent,
    MetronomeReadingCorrectAnswerPreviewComponent,
    MetronomeReadingExamplePreviewComponent,
    MetronomeReadingParametersPreviewComponent,
    MetronomeReadingUserAnswerPreviewComponent,
    NgSelectModule,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    NgSelectModule,
    TextsFilterComponent,
    SharedModule,
    TextGamesSharedModule,
    FontParametersModule,
    FormFieldModule,
    MatTooltip,
  ],
})
export class MetronomeReadingModule {}
